// @ts-nocheck
const CONTACT_FIELDS = ['contactName', 'contactEmail', 'contactPhone'];

const normalizeText = (value) => {
  if (typeof value !== 'string') {
    return '';
  }

  return value.trim();
};

export const parseContactSettings = (settingValue) => {
  if (!settingValue) {
    return {};
  }

  let parsedValue = settingValue;

  if (typeof settingValue === 'string') {
    try {
      parsedValue = JSON.parse(settingValue);
    } catch (error) {
      return {};
    }
  }

  const settings = Array.isArray(parsedValue) ? parsedValue?.[0] : parsedValue;

  if (!settings || typeof settings !== 'object') {
    return {};
  }

  return CONTACT_FIELDS.reduce((acc, fieldName) => {
    const value = normalizeText(settings?.[fieldName]);

    if (value) {
      acc[fieldName] = value;
    }

    return acc;
  }, {});
};

const firstNonEmpty = (...values) => {
  for (const value of values) {
    const normalizedValue = normalizeText(value);

    if (normalizedValue) {
      return normalizedValue;
    }
  }

  return '';
};

const getCreatorName = (createdByUser = {}) => {
  const firstName = normalizeText(createdByUser?.firstname);
  const lastName = normalizeText(createdByUser?.lastname);
  const combinedName = normalizeText(`${firstName} ${lastName}`);

  return firstNonEmpty(
    createdByUser?.contactName,
    createdByUser?.name,
    createdByUser?.fullname,
    createdByUser?.displayName,
    combinedName
  );
};

export const resolveOperatorContact = ({
  trip = {},
  tripContactSettings = {},
  globalContactSettings = {},
  enabled = true
} = {}) => {
  const createdByUser = trip?.createdbyuser || {};
  const tenant = trip?.tenant || {};
  const creatorName = getCreatorName(createdByUser);
  const creatorEmail = firstNonEmpty(
    createdByUser?.email,
    createdByUser?.login
  );
  const tenantPhone = normalizeText(tenant?.tenantphone);

  if (!enabled) {
    return {
      name: creatorName,
      email: creatorEmail,
      phone: tenantPhone
    };
  }

  return {
    name: firstNonEmpty(
      tripContactSettings?.contactName,
      globalContactSettings?.contactName,
      creatorName
    ),
    email: firstNonEmpty(
      tripContactSettings?.contactEmail,
      globalContactSettings?.contactEmail,
      creatorEmail
    ),
    phone: firstNonEmpty(
      tripContactSettings?.contactPhone,
      globalContactSettings?.contactPhone,
      tenantPhone
    )
  };
};

export const withResolvedOperatorContact = (
  trip = {},
  { tripContactSettings, globalContactSettings, enabled = true } = {}
) => {
  const operatorContact = resolveOperatorContact({
    trip,
    tripContactSettings,
    globalContactSettings,
    enabled
  });

  return {
    ...trip,
    operatorContact,
    createdbyuser: {
      ...(trip?.createdbyuser || {}),
      login: operatorContact.email || trip?.createdbyuser?.login || ''
    },
    tenant: {
      ...(trip?.tenant || {}),
      tenantphone: operatorContact.phone || trip?.tenant?.tenantphone || ''
    }
  };
};

export const getOperatorContactLink = (operatorContact = {}, subject = '') => {
  if (operatorContact?.email) {
    const encodedSubject = subject
      ? `?subject=${encodeURIComponent(subject)}`
      : '';
    return {
      href: `mailto:${operatorContact.email}${encodedSubject}`,
      label: operatorContact.email,
      type: 'email'
    };
  }

  if (operatorContact?.phone) {
    return {
      href: `tel:${operatorContact.phone.replace(/\s/g, '')}`,
      label: operatorContact.phone,
      type: 'phone'
    };
  }

  return null;
};
